// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-module--header--2QkJI","title":"Header-module--title--1RLSV","rotation":"Header-module--rotation--pOHlv","pulse":"Header-module--pulse--1vsXN"};